import { Button, Popover, Stack, Tab, Tabs } from '@mui/material';
import React, { useState } from 'react';
import type { Doc } from 'src/@types/docs.js';
import { Iconify } from 'src/components/iconify';
import { useUpdateDocMutation } from '../useUpdateDocMutation';
import { IconEmojiPicker } from './IconEmojiPicker';

type Props = {
  doc: Doc;
  target: null | React.MouseEvent['currentTarget'];
  handleClose: () => void;
};
const tabs = [{ text: 'Emoji', value: 'emoji', component: IconEmojiPicker }];

export const IconPickerPopOver = ({ target, handleClose, doc }: Props) => {
  const open = Boolean(target);
  const { updateDoc } = useUpdateDocMutation();
  const [tab, setTab] = useState(tabs[0]);

  const handleRemoveIcon = async () => {
    await updateDoc({
      _id: doc?._id,
      icon: null,
    });
    handleClose();
  };

  return (
    <Popover
      open={open}
      anchorEl={target}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      slotProps={{
        paper: {
          sx: { p: 1, width: '360px' },
        },
      }}
    >
      <Tabs value={tab.value} onChange={(event, newValue) => setTab(newValue)}>
        {tabs.map((item) => (
          <Tab key={item.value} value={item.value} label={item.text} />
        ))}
        <Button
          size="small"
          sx={{ ml: 'auto', alignSelf: 'center' }}
          startIcon={<Iconify icon="tabler:trash" />}
          onClick={handleRemoveIcon}
        >
          remove
        </Button>
      </Tabs>

      <Stack sx={{ width: 400, maxHeight: 600, overflowY: 'auto' }}>
        {tab?.component && doc && (
          <tab.component handleClose={handleClose} docId={doc?._id} />
        )}
      </Stack>
    </Popover>
  );
};
